import { render, staticRenderFns } from "./FormIndirizzoComponent.vue?vue&type=template&id=4f3d2f7d&scoped=true"
import script from "./FormIndirizzoComponent.vue?vue&type=script&lang=js"
export * from "./FormIndirizzoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3d2f7d",
  null
  
)

export default component.exports